import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Tab, TabList, useStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'

const SearchCategoryTabs = ({productSearchResult, tabButtonLabels, faqArticlesHits}) => {
    const styles = useStyleConfig('PageHeader')

    const productManuals = useMemo(() => {
        const manuals = productSearchResult?.hits?.map((hit) => {
            const productManuals = hit?.representedProduct?.c_manualDocument
                ?.replace(/[\r\n]+/g, '')
                ?.trim()
            const parsedProductManuals = productManuals ? JSON.parse(productManuals) : []
            return parsedProductManuals.length
        })
        return manuals
    }, [productSearchResult])

    return (
        <TabList
            {...styles.searchContainerButtons}
            sx={{
                '::-webkit-scrollbar': {display: 'none'},
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
            }}
        >
            {Object.keys(tabButtonLabels).map((key) => (
                <Tab
                    key={tabButtonLabels[key].id}
                    variant="icon-button"
                    {...styles.searchSectionButton}
                    _focusVisible={{boxShadow: 'unset'}}
                >
                    <FormattedMessage
                        {...tabButtonLabels[key]}
                        values={{
                            total:
                                key === 'productResults'
                                    ? productSearchResult?.total || 0
                                    : key === 'manuals'
                                    ? productManuals?.reduce((a, b) => a + b, 0)
                                    : key === 'faq'
                                    ? faqArticlesHits
                                    : 0,
                        }}
                    />
                </Tab>
            ))}
        </TabList>
    )
}

SearchCategoryTabs.propTypes = {
    productSearchResult: PropTypes.object,
    tabButtonLabels: PropTypes.object,
    faqArticlesHits: PropTypes.number,
}

export default SearchCategoryTabs
